export default "skymp5-front/d0c143bd3bf8a5a13950964032daddb0.mp3";